module.exports = __webpack_public_path__ + "static/media/Q1-2.f5472cd4.jpg";